import React from 'react';

import {
  activityTemplates,
  PermissionWall
} from 'modules';

import { Grid } from '@mui/material';
import * as AppleCareAgreementsWidget from './AppleCareAgreementsWidget/AppleCareAgreementsWidget';
import * as CurrentDevelopmentWorkWidget from './CurrentDevelopmentWorkWidget/CurrentDevelopmentWorkWidget';
import * as NavigationWidget from './NavigationWidget/NavigationWidget';
import * as OrderListWidget from './OrderListWidget/OrderListWidget';
import * as RecentReturnAuthorizationListWidget from './RecentReturnAuthorizationListWidget/RecentReturnAuthorizationListWidget';
import * as SkuSwapWidget from './SkuSwapWidget/SkuSwapWidget';
import * as StoreListWidget from './StoreListWidget/StoreListWidget';



export const RootAdminActivity: React.FC = () => {
  return (
    <activityTemplates.AdminActivityTemplate.FC>
      <Grid
        container
        spacing={2}>
        <Grid
          item
          xs={12}
          md={4}>
          <NavigationWidget.FC />
        </Grid>

        <Grid
          item
          xs={12}
          md={4}>
          <PermissionWall.FC requiresPermissions={['salesOrder_view']}>
            <OrderListWidget.FC salesChannel="ecommerce" />
          </PermissionWall.FC>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}>
          <PermissionWall.FC requiresPermissions={['salesOrder_view']}>
            <OrderListWidget.FC salesChannel="thirdPartyLogistics" />
          </PermissionWall.FC>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}>
          <PermissionWall.FC requiresPermissions={['returnAuthorization_view']}>
            <RecentReturnAuthorizationListWidget.FC />
          </PermissionWall.FC>
        </Grid>

        <Grid
          item
          xs={12}
          md={8}>
          <StoreListWidget.FC />
        </Grid>

        <Grid
          item
          xs={12}
          md={6}>
          <PermissionWall.FC requiresPermissions={['inventory_createSkuSwap']}>
            <SkuSwapWidget.FC />
          </PermissionWall.FC>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}>
          <PermissionWall.FC requiresPermissions={['insurance_viewAppleCareAgreement']}>
            <AppleCareAgreementsWidget.FC />
          </PermissionWall.FC>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}>
          <PermissionWall.FC requiresPermissions={['platform_viewJiraTickets']}>
            <CurrentDevelopmentWorkWidget.FC />
          </PermissionWall.FC>
        </Grid>
      </Grid>
    </activityTemplates.AdminActivityTemplate.FC>
  );
};
